import { createContext } from 'react';

import { BaseTracker } from '../../tracking';

export interface TrackerContextValues {
  tracker: BaseTracker;
}

export const TrackerContext = createContext<TrackerContextValues | undefined>(undefined);
